/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import styles from './../../pages/Clinical_Profile/Investigation_Diagnosis/investigation_diagnosis.module.css';
import {
  Grid,
  ThemeProvider,
  Button,
  Box,
  Typography,
  Dialog,
} from '@mui/material';
import { theme } from '../../theme';
import PgtOrders from './pgtOrders';
import PgtResult from './PgtResult';
import axios from 'axios';
import { usePatientContext } from '../patinetProvider';
import { Patientv2 } from '../../types';

export default function PgtHome2() {
  const [selectedPatient, setselectedPatient] = useState<Patientv2 | null>(null);
  const [activeTab, setActiveTab] = useState('Test');
  const { MainpatientDetails } = usePatientContext();

  // Dialog State
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [loginUrl, setLoginUrl] = useState('');

  // Called after login redirect with token
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromRedirect = params.get('token');

    if (tokenFromRedirect) {
      localStorage.setItem('progenesis_token', tokenFromRedirect);
      window.history.replaceState({}, document.title, window.location.pathname);
      setOpenLoginDialog(false); // Optional: close dialog if redirect ends up in same app
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDatafromHeader = (data: any) => {
    console.log('Selected Patient Data:', data);
    console.log('Selected Patient ID:', MainpatientDetails);
    setselectedPatient(MainpatientDetails);
  };

  const handleProgenesisLogin = () => {
    const clientId = '21';
    const redirectUri = encodeURIComponent('https://stage-api.vidaisolutions.com/api/pgta/redirect');
    const state = encodeURIComponent('3');
    const scope = ''; // Add scope if required

    const authUrl = `https://dev.progenesis.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&response_type=code&scope=${scope}`;

    setLoginUrl(authUrl);
    setOpenLoginDialog(true);
  };

  const fetchPhysicians = async () => {
    const proxyEndpoint = 'https://stage-api.vidaisolutions.com/api/pgta/proxy';
    const token = localStorage.getItem('progenesis_token');

    if (!token) {
      console.warn('No token found. Please login to Progenesis first.');
      return;
    }

    try {
      const response = await axios.post(
        `${proxyEndpoint}?url=/api/v2/doctors&method=GET`,
        {
          body: {},
          headers: {
            'Custom-Header': 'value',
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.data) {
        console.log('Physicians:', response.data.data);
        // setPhysicians(response.data.data);
      }
    } catch (err) {
      console.error('Proxy request failed:', err);
    }
  };

  useEffect(() => {
    if (selectedPatient?.id) {
      fetchPhysicians();
    }
  }, [selectedPatient]);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <HeaderProfile onData={handleDatafromHeader} />

        <Grid sx={{ my: 2, px: 3, mt: 6 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" fontWeight="bold">
              Preimplantation Genetic Screening Test (PGT)
            </Typography>
            <Button onClick={handleProgenesisLogin} variant="outlined">
              Login to Progenesis
            </Button>
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <div className={styles.tabs}>
              <button
                className={styles.tab}
                style={{
                  backgroundColor: activeTab === 'Test' ? 'white' : 'transparent',
                  color: activeTab === 'Test' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Test' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Test')}
              >
                Order
              </button>
              <button
                className={styles.tab}
                style={{
                  backgroundColor: activeTab === 'Diagnosis' ? 'white' : 'transparent',
                  color: activeTab === 'Diagnosis' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Diagnosis' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Diagnosis')}
              >
                PGT Result
              </button>
            </div>
          </Box>

          <Box mt={2}>
            {selectedPatient?.id && activeTab === 'Test' && <PgtOrders />}
            {selectedPatient?.id && activeTab === 'Diagnosis' && <PgtResult />}
          </Box>
        </Grid>

        {/* Progenesis Login Dialog */}
        <Dialog
          open={openLoginDialog}
          onClose={() => setOpenLoginDialog(false)}
          fullWidth
          maxWidth="md"
        >
          <Box height="600px" position="relative">
            <iframe
              src={loginUrl}
              title="Progenesis Login"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          </Box>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
